import React from "react";
import "../css/Thanks.css";
import { Link } from "react-router-dom";

import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

export default function ThankYou() {
  return (
    <div>
      <Navbar />
      <div className="container mt-15">
        <h2>Your order has been placed. Thanks for choosing us.</h2>
        <Link to="/">
          <button className="btn btn-main rounded-pill border p-2 text-center mt-3 confirm-button">
            Continue shopping
          </button>
        </Link>
      </div>
      <Footer />
    </div>
  );
}
